/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import Box from "@mui/material/Box";
import TuneIcon from "@mui/icons-material/Tune";

import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

import { Checkbox, Grid, Typography } from "@mui/material";

import classes from "./FilterOptions.module.css";
import {
  selectedApplications,
  selectedRegions,
  //sendFilteredJson,
} from "../../store/Tenant/tenant-actions";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

import { IErrorProps, OptionsProduct } from "../../models";

import Loader from "../Loader/Loader";
import DialogForError from "../SharedComponents/DialogForError";
import ToastBarForError from "../SharedComponents/ToastBarForError";
import FilterJson from "../../models/FilterJson";
import { Region } from "../../models/OptionsModels/Region";
import { getRegionCheckBoxCount } from "./getRegionCheckBoxCount";
import { getAppCheckBoxCount } from "./getAppCheckBoxCount";
import React from "react";
type Anchor = "top" | "left" | "bottom" | "filter";
const app = "apps";
const region = "region";
const undefined1 = "undefined";

export interface IProps1 {
  region: string;
  customerIds: Array<string>;
}
export interface IProps2 {
  app: string;
  customerIds: Array<string>;
}

export default function TemporaryDrawer({
  isFilterDisabled,
  filteringCritera,
  onFilteringCriteriaChange,
}: {
  isFilterDisabled?: boolean;
  filteringCritera: FilterJson;
  onFilteringCriteriaChange: any;
}) {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    filter: false,
  });
  const [isLoading, setIsLoading] = useState(false);

  const RegionAndCustomerIdMapping = useRef<Array<IProps1>>([]);

  const optionsRegion: Region[] = useSelector(
    (state: RootState) => state.cart.availableRegions
  );

  const optionsProductList: OptionsProduct[] = useSelector(
    (state: RootState) => state.cart.availableProducts
  );

  const regionFilterCriteria: string[] = filteringCritera.region;
  const appFilterCriteria: string[] = filteringCritera.assignedApps;

  const StoreFilterdata: any = useSelector(
    (state: RootState) => state.cart.filterData
  );

  const parent1 = useRef(undefined1);

  const handleClear = () => {
    setSelectedApps([]);
    setSelectedRegion([]);
  };

  const handleCancel = () => {
    setSelectedRegion(regionFilterCriteria);
    setSelectedApps(appFilterCriteria);
    setState({ top: false, left: false, bottom: false, filter: false });
  };
  const [selectedApps, setSelectedApps] = useState<string[]>([]);
  const [selectedRegion, setSelectedRegion] = useState<string[]>([]);

  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);
  const [errorList, setErrorList] = useState<Array<IErrorProps>>([]);
  const [parent, setParent] = useState(undefined1);
  const [count, setCount] = useState(0);
  const AppValues = useRef<Array<IProps2>>([]);
  const [countApps, setCountApps] = useState(0);
  const [countRegions, setCountRegions] = useState(0);

  // useEffect(() => {
  //   setCountApps(AppValues.current.filter((x) => x?.app).length);
  // }, [AppValues]);

  // useEffect(() => {
  //   setCountRegions(
  //     RegionAndCustomerIdMapping.current.filter((x) => x?.region).length
  //   );
  // }, [RegionAndCustomerIdMapping]);
  useEffect(() => {
    setSelectedApps(filteringCritera.assignedApps);
    setSelectedRegion(filteringCritera.region);
  }, [filteringCritera]);

  useEffect(() => {
    SetAppValuesToMasterData();
    SetRegionValuesToMasterData();
    // Set RegionsCount and AppsCount for filter
    setCountApps(AppValues.current.length);
    setCountRegions(RegionAndCustomerIdMapping.current.length);
  }, [StoreFilterdata]);

  useEffect(() => {
    setParentBasedOnCheckBoxSelection();

    getProductsCount();
    getLocationCount();
  }, [selectedApps, selectedRegion]);

  useEffect(() => {
    // Code 1

    if (parent !== undefined) {
      if (parent === app) {
      } else if (parent === region) {
      }
    }
  }, [parent, count]);

  // istanbul ignore next
  // Handle checkbox selection
  // For selected region
  const handleCheckboxChangeRegion = (option: string) => {
    if (selectedRegion.includes(option)) {
      setSelectedRegion(selectedRegion.filter((item) => item !== option));
    } else {
      setSelectedRegion([...selectedRegion, option]);
    }
  };

  // istanbul ignore next
  const getApplicationIdfromName = (id: string) => {
    return optionsProductList.find((x) => x.applicationName === id)
      ?.applicationId;
  };

  // istanbul ignore next
  // Handle checkbox selection
  // For selected apps change
  const handleCheckboxChangeApps = (option: string) => {
    if (selectedApps.includes(option)) {
      setSelectedApps(selectedApps.filter((item) => item !== option));
    } else {
      setSelectedApps([...selectedApps, option]);
    }
  };

  // istanbul ignore next
  function setParentBasedOnCheckBoxSelection() {
    RegionAndCustomerIdMapping.current = [];

    if (
      selectedApps.length === 0 &&
      selectedRegion.length === 0 &&
      parent !== undefined1
    ) {
      parent1.current = undefined1;
      setParent(undefined1);
    } else if (
      selectedApps.length >= 1 &&
      selectedRegion.length === 0 &&
      parent !== app
    ) {
      parent1.current = app;
      setParent(app);
    } else if (
      selectedApps.length === 0 &&
      selectedRegion.length >= 1 &&
      parent !== region
    ) {
      parent1.current = region;
      setParent(region);
    }

    if (parent1.current === app) {
      /* Create AppAndCustomerIdMapping*/
      SetAppValuesToMasterData();
      RegionAndCustomerIdMapping.current = [];
      /* End create AppAndCustomerIdMapping*/
      /* Create  RegionAndCustomerIdMapping */
      StoreFilterdata?.apps?.forEach((x: any) => {
        if (
          selectedApps.includes(
            getApplicationIdfromName(x.applicationName) as string
          )
        ) {
          (x.location as Array<any>).forEach((z: any) => {
            ///
            if (
              //added for coverity
              (RegionAndCustomerIdMapping &&
                RegionAndCustomerIdMapping?.current.length === 0) ||
              RegionAndCustomerIdMapping?.current.findIndex(
                (d) => d.region === z.locationName
              ) === -1
            ) {
              RegionAndCustomerIdMapping?.current.push({
                region: z.locationName,
                customerIds: [],
              });
            }

            (z.customerId as Array<string>).forEach((e1) => {
              let regionArray = RegionAndCustomerIdMapping?.current.find(
                (d) => d.region === z.locationName
              );

              if (
                //removed and added for coverity
                // typeof regionArray !== "undefined" &&
                regionArray &&
                regionArray !== null &&
                !regionArray?.customerIds?.includes(e1)
              ) {
                (regionArray as IProps1).customerIds = [
                  ...(regionArray as IProps1).customerIds,
                  e1,
                ];
              }
            });
          });
        }
      });
      /* End Create  RegionAndCustomerIdMapping */
    }
    if (parent1.current === undefined1) {
      SetAppValuesToMasterData();
      SetRegionValuesToMasterData();
    }
    if (parent1.current === region) {
      SetRegionValuesToMasterData();
      AppValues.current = [];
      /* Create App and customerId mapping */
      StoreFilterdata?.region?.forEach((x: any) => {
        if (selectedRegion.includes(x.locationName as string)) {
          (x.apps as Array<any>).forEach((z: any) => {
            if (
              (AppValues &&
                //added for coverity
                AppValues?.current.length === 0) ||
              AppValues?.current.findIndex((d) => d.app === z.appName) === -1
            ) {
              AppValues?.current.push({
                app: z.appName,
                customerIds: [],
              });
            }

            (z.customerId as Array<string>).forEach((e1) => {
              let regionArray = AppValues?.current.find(
                (d) => d.app === z.appName
              );

              if (
                // typeof regionArray !== undefined &&
                regionArray &&
                // regionArray !== null &&
                !regionArray?.customerIds.includes(e1)
              ) {
                (regionArray as IProps2).customerIds = [
                  ...(regionArray as IProps2).customerIds,
                  e1,
                ];
              }
            });
          });
        }
      });

      /* End Create App and customerId mapping */
    }

    setCount(count + 1);
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const postData: FilterJson = {
      assignedApps: selectedApps,
      region: selectedRegion,
    };

    onFilteringCriteriaChange(postData);

    setState({ ...state, filter: false });
  };

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }

      setState({ ...state, [anchor]: open, filter: true });
    };

  // istanbul ignore next
  const list = (anchor: Anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    ></Box>
  );

  // Error props handlers
  // istanbul ignore next
  const onDialogForServerCloseHandler = () => setOpenDialogServerError(false);

  // istanbul ignore next
  const onDialogForNOURLCloseHandler = () => setOpenDialogNoURLError(false);

  // istanbul ignore next
  // Handle toastbar onClick
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  // get App Count
  // istanbul ignore next
  function getProductsCount() {
    if (parent1.current === "app" || parent1.current === undefined1) {
      setCountApps(optionsProductList?.length);
    }
    let count = 0;
    let count1 = AppValues.current.filter((x) => x?.customerIds?.length > 0);

    setCountApps(count1.length);
  }

  // get Location Count
  // istanbul ignore next
  function getLocationCount() {
    if (parent1.current === "region" || parent1.current === undefined1) {
      setCountRegions(optionsRegion?.length);
    }
    let count = 0;
    count = RegionAndCustomerIdMapping.current.filter(
      (x) => x?.customerIds?.length > 0
    ).length;

    setCountRegions(count);
  }

  // End Error props handlers

  return (
    <div>
      {(["filter"] as const).map((anchor) => (
        <div key={anchor}>
          <Button
            disabled={isFilterDisabled}
            data-testid="filterbtn"
            startIcon={
              <TuneIcon
                sx={{
                  transform: "rotate(90deg)",
                  width: "0.7rem",
                  height: "0.7rem",
                }}
              />
            }
            sx={{
              color: "#F0F0F0",
              background: "#707070",
              border: "1px solid #707070",
              fontSize: "0.7rem",
              height: "4vh",
              width: "auto",
              paddingRight: "2vw",
              paddingLeft: "2vw",
            }}
            onClick={toggleDrawer(anchor, true)}
          >
            <div style={{ textTransform: "capitalize" }}>{anchor}</div>
          </Button>
          <Drawer
            anchor={"right"}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            variant="temporary"
          >
            <Box
              sx={{
                color: "#F0F0F0",
                // padding: "1vh",
                backgroundColor: "#272727",
                height: "100%",
                marginTop: "4vh",
                width: "20vw",
                // minwidth: "250px",
              }}
            >
              <Grid
                container
                direction="row"
                sx={{
                  height: "90%",
                  backgroundColor: "#272727",
                  width: "100%",
                }}
              >
                <Grid
                  item
                  sx={{
                    width: "100%",
                    height: "15%",
                    position: "relative",
                    flexGrow: 0,
                    paddingLeft: "1vw",
                  }}
                >
                  <Grid container direction="row">
                    <Grid
                      item
                      width="50%"
                      className={classes.filterHeadingGrid}
                    >
                      <Typography className={classes.filterHeading}>
                        Filter
                      </Typography>
                    </Grid>

                    <Grid container justifyContent="flex-end" width="50%">
                      <Button
                        sx={{
                          width: "0.5vw",
                          justifyContent: "flex-end",
                        }}
                        data-testid="handleCancel_Close"
                        onClick={handleCancel}
                      >
                        <CloseIcon sx={{ color: "#F0F0F0" }} />
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid container direction="row">
                    <Grid
                      item
                      sx={{
                        padding: "0.8vh",
                        paddingBottom: "0.4vh",
                        paddingTop: "1.5vh",
                        width: "50%",
                      }}
                      className={classes.filterby}
                    >
                      Filter By
                    </Grid>

                    <Grid
                      container
                      justifyContent="flex-end"
                      width="50%"
                      sx={{
                        padding: "1vh",
                      }}
                    >
                      <Button
                        sx={{ padding: 0 }}
                        data-testid="handleClearButton"
                        onClick={handleClear}
                        startIcon={<RestartAltIcon />}
                        className={classes.clearall}
                      >
                        Clear all
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="column"
                  sx={{
                    width: "100%",
                    height: "80%",
                    position: "relative",

                    flexGrow: 1,
                    overflowY: "auto",
                    // paddingLeft: "1vw",
                    marginLeft: "1vw",
                  }}
                >
                  <Grid item sx={{ width: "100%" }}>
                    <form>
                      <Grid
                        item
                        sx={{ width: "100%" }}
                        className={classes.subHeadingFilter}
                        // padding="0.7%"
                      >
                        {/* Assigned Apps {`(${optionsProductList?.length})`} */}
                        Assigned Apps {`(${countApps})`}
                      </Grid>
                      <Grid item className={classes.subHeadingFilter}>
                        {optionsProductList?.map((option) =>
                          getAppCheckBoxCount(AppValues, option) === 0 ? (
                            <div></div>
                          ) : (
                            <>
                              <div
                                key={option?.applicationId}
                                className={classes.optionsCheck}
                              >
                                <Checkbox
                                  sx={{
                                    "&.MuiButtonBase-root": {
                                      color:
                                        getAppCheckBoxCount(
                                          AppValues,
                                          option
                                        ) == 0
                                          ? "#8B8484"
                                          : "FFFFFF",
                                    },
                                  }}
                                  checked={
                                    selectedApps !== null &&
                                    selectedApps !== undefined
                                      ? selectedApps.includes(
                                          option?.applicationId
                                        )
                                      : false
                                  }
                                  disabled={
                                    getAppCheckBoxCount(AppValues, option) == 0
                                  }
                                  className={classes.Check}
                                  onChange={() => {
                                    handleCheckboxChangeApps(
                                      option?.applicationId
                                    );
                                  }}
                                  inputProps={{
                                    "aria-label": option?.applicationId,
                                  }}
                                />
                                <span
                                  style={{
                                    color:
                                      getAppCheckBoxCount(AppValues, option) ===
                                      0
                                        ? "#909090"
                                        : "#FFFFFF",
                                  }}
                                >
                                  {option.applicationName}(
                                  {getAppCheckBoxCount(AppValues, option)})
                                </span>
                              </div>
                            </>
                          )
                        )}
                      </Grid>
                      <Grid
                        item
                        className={classes.subHeadingFilter}
                        padding="0.5%"
                      >
                        {" "}
                        Location/Region {`(${countRegions})`}
                      </Grid>
                      <Grid item className={classes.subHeadingFilter}>
                        {optionsRegion?.map((option) =>
                          getRegionCheckBoxCount(
                            RegionAndCustomerIdMapping,
                            option
                          ) === 0 ? (
                            <div></div>
                          ) : (
                            <div
                              key={option.regionName}
                              className={classes.optionsCheck}
                            >
                              <Checkbox
                                className={classes.Check}
                                checked={selectedRegion?.includes(
                                  option.regionName
                                )}
                                sx={{
                                  "&.MuiButtonBase-root": {
                                    color:
                                      getRegionCheckBoxCount(
                                        RegionAndCustomerIdMapping,
                                        option
                                      ) == 0
                                        ? "#8B8484"
                                        : "FFFFFF",
                                  },
                                }}
                                disabled={
                                  getRegionCheckBoxCount(
                                    RegionAndCustomerIdMapping,
                                    option
                                  ) === 0
                                }
                                onChange={() => {
                                  handleCheckboxChangeRegion(
                                    option?.regionName
                                  );
                                  //getProductsCount();
                                }}
                                inputProps={{
                                  "aria-label": option?.regionName,
                                }}
                              />
                              <span
                                style={{
                                  color:
                                    getRegionCheckBoxCount(
                                      RegionAndCustomerIdMapping,
                                      option
                                    ) === 0
                                      ? "#909090"
                                      : "#FFFFFF",
                                }}
                              >
                                {option.regionName}(
                                {getRegionCheckBoxCount(
                                  RegionAndCustomerIdMapping,
                                  option
                                )}
                                )
                              </span>
                            </div>
                          )
                        )}
                      </Grid>
                    </form>
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    width: "100%",
                    height: "10%",
                    flexGrow: 0,
                    bottom: 0,
                    position: "fixed",
                    padding: "1%",
                    borderTop: "1px solid black",
                    // wordWrap: "true",
                    // overflow: "hidden",
                  }}
                >
                  <Button
                    className={classes.cancelButton}
                    data-testid="handleCancelButton"
                    onClick={handleCancel}
                    sx={{ margin: "0.5vw" }}
                  >
                    Cancel{" "}
                  </Button>

                  <Button
                    //type="submit"
                    className={classes.filterButtonShow}
                    data-testid="submit_btn"
                    sx={{ margin: "0.5vw", marginLeft: 12 }}
                    onClick={(ev: any) => handleSubmit(ev)}
                  >
                    Show Results
                  </Button>
                </Grid>
              </Grid>
              {/* <Grid
                sx={{
                  backgroundColor: "blue",
                  width: "100%",
                  height: "10%",
                  position: "fixed",
                }}
              >
                <Button
                  className={classes.cancelButton}
                  onClick={handleCancel}
                  sx={{ margin: "0.5vw", marginLeft: "2vw" }}
                >
                  Cancel{" "}
                </Button>
                nasdj
              </Grid> */}
            </Box>
            {list(anchor)}
          </Drawer>
        </div>
      ))}
      {isLoading && <Loader />}

      {openDialogServerError && (
        // istanbul ignore next
        <DialogForError
          open={openDialogServerError}
          onClose={onDialogForServerCloseHandler}
          errorList={errorList}
          errorType="serverError"
        />
      )}
      {/* /// Open NoURL error */}

      {openDialogNoURLError && (
        // istanbul ignore next
        <DialogForError
          open={openDialogNoURLError}
          onClose={onDialogForNOURLCloseHandler}
          errorList={errorList}
          errorType="noURLFoundError"
        />
      )}
      {/* /// Open Toast error */}
      {openToastError && (
        // istanbul ignore next
        <ToastBarForError
          open={openToastError}
          onClose={handleToastBarClose}
          errorList={errorList}
        />
      )}
    </div>
  );

  // istanbul ignore next
  function SetAppValuesToMasterData() {
    AppValues.current = [];

    if (
      StoreFilterdata?.apps !== undefined &&
      StoreFilterdata?.apps !== null &&
      StoreFilterdata?.apps?.length !== 0
    )
      (StoreFilterdata?.apps as Array<any>).forEach((app: any) => {
        if (app?.applicationName) {
          const customerIds: string[] = [];
          app?.location.forEach((location: any) => {
            customerIds.push(...location.customerId);
          });

          AppValues.current.push({
            app: app.applicationName,
            customerIds: Array.from(new Set(customerIds)),
          });
        }
      });
  }

  // istanbul ignore next
  function SetRegionValuesToMasterData() {
    if (
      StoreFilterdata?.region !== undefined &&
      StoreFilterdata?.region?.length !== 0 &&
      StoreFilterdata?.region !== null
    ) {
      RegionAndCustomerIdMapping.current = [];
      (StoreFilterdata?.region as Array<any>).forEach((region) => {
        if (region?.locationName) {
          const customerIds: string[] = [];
          region?.apps.forEach((app: any) => {
            customerIds.push(...app.customerId);
          });

          RegionAndCustomerIdMapping.current.push({
            region: region.locationName,
            customerIds: Array.from(new Set(customerIds)),
          });
        }
      });
    }
  }
}
